export default "/kiban/_next/static/images/mount-fb69285f3799b755f6669f68221248e1.png";